import React from 'react';

import './Offering.css';
import { Helmet } from 'react-helmet-async';




const Therapie = () => (
    <>
    <Helmet>
                <title>Ernährungstherapie</title>
                <meta name="description" content='Ernährungstherapie für ernährungsabhängige Erkrankungen und krankheitsbedingte Ernährungsprobleme. 
                Gesetzliche Krankenkassen bezuschussen oder übernehmen 5 oder mehr Beratungen im Rahmen der Rehabilitation (§ 43 SGB V). 
                Beatung bei Adipositas, Herz-Kreislauf-Erkrankungen, Diabetes, gastrointestinale Probleme, Leber- und Gallenwegserkrankungen, 
                Pankreaserkrankungen, Nahrungsmittelunverträglichkeiten, Nierenerkrankungen, Osteoporose, Rheuma, Multiple Sklerose, bariatrische Operationen, 
                onkologische Erkrankungen, Mangelernährung und Essstörungen. Kostenlose Kostenvoranschlagserstellung nach ärztlicher Zuweisung für Kostenübernahme. 
                Beratungen auch online per Zoom, Skype, WhatsApp-Video-Chat und telefonisch.' />
            </Helmet>
    <div className='Therapie'>
        <div className="BeratungWrapper">
            <div className='entrycontent'>

                <h2 className='header'>Ernährungstherapie</h2>

                <p className='text'>Die Ernährungstherapie wendet sich an Menschen mit ernährungsabhängigen Erkrankungen, die durch eine Ernährungsumstellung positiv beeinflusst, gelindert oder beseitigt werden können sowie an Menschen mit krankheitsbedingten Ernährungsproblemen.
                    Im Rahmen der Rehabilitation ( § 43 SGB V) bezuschussen oder übernehmen die gesetzlichen Krankenkassen 5 oder mehr Beratungen. Die Erstberatung dauert i.d.R. eine Stunde, die 4 Folgeberatungen jeweils 30 Minuten. 
                    Die Beratungen können in Präsenz oder Online stattfinden.</p>
                <br/>
                <p className='text'>Eine Beratung ist zielführend bei:</p>
                <ul>
                    <li className='listentry'>Adipositas und metabolisches Syndrom<br />
                        
                    </li>
                    <li className='listentry'>Dyslipoproteinämien, Arteriosklerose und Herz-Kreislauf-Erkrankungen
                        <ul>
                            <li className='listentry'>Erhöhte Cholesterinwerte</li>
                            <li className='listentry'>Erhöhte Triglyceridwerte</li>
                            <li className='listentry'>KHK</li>
                            <li className='listentry'>Herzinsuffizienz</li>
                            <li className='listentry'>Arterielle Hypertonie<br />
                                
                            </li>
                        </ul>
                    </li>
                    <li className='listentry'>Diabetes mellitus
                        <ul>
                            <li className='listentry'>Typ 2</li>
                            <li className='listentry'>Gestationsdiabetes<br />
                                
                            </li>
                        </ul>
                    </li>
                    <li className='listentry'>Erkrankungen des Gastrointestinaltrakts
                        <ul>
                            <li className='listentry'>Refluxösophagitis</li>
                            <li className='listentry'>Zustand nach Magenresektion/Dumpingsyndrom</li>
                            <li className='listentry'>Gluteninduzierte Enterophatie (Sprue/Zöliakie)</li>
                            <li className='listentry'>Chronisch entzündliche Darmerkrankungen (Morbus Cron, Colitis, Ulcerosa)</li>
                            <li className='listentry'>Reizdarmsyndrom</li>
                            <li className='listentry'>Chronische Obstipation</li>
                            <li className='listentry'>Kolondivertikulose<br />
                                
                            </li>
                        </ul>
                    </li>
                    <li className='listentry'>Erkrankungen der Leber und Gallenwege
                        <ul>
                            <li className='listentry'>Leberinsuffizienz</li>
                            <li className='listentry'>Fettleber<br />
                                
                            </li>
                        </ul>
                    </li>
                    <li className='listentry'>Erkrankungen der Pankreas
                        <ul>
                            <li className='listentry'>Chronische Pankreatitis<br />
                                
                            </li>
                        </ul>
                    </li>
                    <li className='listentry'>Nahrungsmittelunverträglichkeiten
                        <ul>
                            <li className='listentry'>Nahrungsmittelallergien</li>
                            <li className='listentry'>Kreuzallergien</li>
                            <li className='listentry'>Histaminintoleranz</li>
                            <li className='listentry'>Lactoseintoleranz</li>
                            <li className='listentry'>Fruktoseintoleranz</li>
                            <li className='listentry'>Bakterielle Fehlbesiedlung</li>

                                
                        </ul>
                    </li>
                    <li className='listentry'>Nierenerkrankungen
                        <ul>
                            <li className='listentry'>Chronisches Nierenversagen (Praedialyse, Dialyse)<br />
                                
                            </li>
                        </ul>
                    </li>
                    <li className='listentry'>Osteoporose, Hyperurikämie und Gicht<br />
                        
                    </li>
                    <li className='listentry'>Rheumatischer Formenkreis
                        <ul>
                            <li className='listentry'>Rheuma</li>
                            <li className='listentry'>Arthritis</li>
                            <li className='listentry'>Polyarthritis<br />
                                
                            </li>
                        </ul>
                    </li>
                    <li className='listentry'>Muliple Sklerose<br />
                        
                    </li>

                    <li className='listentry'>Bariatrische Operation<br />
                        
                    </li>

                    <li className='listentry'>Onkologische Erkrankungen<br />
                        
                    </li>
                    <li className='listentry'>Mangelernährung<br />
                        
                    </li>
                    <li className='listentry'>Begleitend zur Psychotherapie bei Essstörungen</li>
                </ul>

            </div>

        </div >

    </div >
    
    </>
    


)

export default Therapie;